import { render, staticRenderFns } from "./leaderData.vue?vue&type=template&id=61e95bee&scoped=true&class=full-height"
import script from "./leaderData.vue?vue&type=script&lang=js"
export * from "./leaderData.vue?vue&type=script&lang=js"
import style0 from "./leaderData.vue?vue&type=style&index=0&id=61e95bee&lang=css"
import style1 from "./leaderData.vue?vue&type=style&index=1&id=61e95bee&scoped=true&lang=css"
import style2 from "./leaderData.vue?vue&type=style&index=2&id=61e95bee&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61e95bee",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\GitHub\\ita.GroupTravel.Website\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('61e95bee')) {
      api.createRecord('61e95bee', component.options)
    } else {
      api.reload('61e95bee', component.options)
    }
    module.hot.accept("./leaderData.vue?vue&type=template&id=61e95bee&scoped=true&class=full-height", function () {
      api.rerender('61e95bee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ita/components/leaderData.vue"
export default component.exports